export default __webpack_public_path__ + "static/slateplan_preview-f89f0ebd8dd995fcdec5d2414e15baa2.png";